import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import { Link } from "react-router-dom";
import "assets/theme/admin_list.css";
import { FaFileAlt, FaPlus, FaEye } from "react-icons/fa";

const ComplaintList = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(null);
  const [villages, setVillages] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    status: "",
    priority: "",
    village_id: "",
    department_id: "",
  });

  const loadVillages = async () => {
    try {
      const data = await apiFetch("leader_admin/get_villages_by_ward_id");
      setVillages(data.data || []);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadComplaints = async () => {
    setLoading(true);
    try {
      const query = `leader_admin/get_all_complaints?page=${page}&limit=${limit}&status=${filters.status}&priority=${filters.priority}&village_id=${filters.village_id}&department_id=${filters.department_id}`;
      const data = await apiFetch(query);

      setComplaints(data.complaints || []);
      setTotalPages(data.pagination?.totalPages || 1);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadDepartments = async () => {
    try {
      const data = await apiFetch("super_admin/list_department");
      setDepartments(data.departments || data || []);
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadComplaints();
  }, [page, filters]);

  useEffect(() => {
    loadVillages();
    loadDepartments();
  }, []);

  const handleFilterChange = (e) => {
    setPage(1);
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusChange = async (complaintId, newStatus) => {
    if (newStatus === "Verified") {
      setUpdating({ id: complaintId, status: newStatus });
    }

    try {
      await apiFetch(`leader_admin/update_status/${complaintId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: newStatus }),
      });

      setComplaints((prev) =>
        prev.map((item) =>
          item.complaint_id === complaintId ? { ...item, status: newStatus } : item
        )
      );
    } catch (error) {
      alert(error.message);
    } finally {
      setUpdating(null);
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Pending":
        return "badge-status badge-status-pending";
      case "Resolved":
        return "badge-status badge-status-resolved";
      case "Rejected":
        return "badge-status badge-status-rejected";
      case "Verified":
        return "badge-status badge-status-verified";
      case "In Progress":
        return "badge-status badge-status-in-progress";
      default:
        return "badge-status badge-status-info";
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "Pending":
        return "प्रलंबित";
      case "Resolved":
        return "निकाली";
      case "Rejected":
        return "नाकारले";
      case "Verified":
        return "पडताळले";
      case "In Progress":
        return "प्रक्रियेत";
      default:
        return status;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaFileAlt />
            </div>
            <div>
              <h4 className="admin-header-title">तक्रार व्यवस्थापन यादी</h4>
              <p className="admin-header-subtitle mb-0">
                नागरिकांच्या तक्रारी पहा, प्रगती ट्रॅक करा आणि स्थिती अद्ययावत करा
              </p>
            </div>
          </div>
          <Link to="/add_complaints" className="btn-admin-add">
            <FaPlus /> नवीन तक्रार जोडा
          </Link>
        </div>

        {/* Filter Bar */}
        <div className="admin-filter-card">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label text-xs fw-bold text-uppercase text-secondary mb-1">स्थितीनुसार निवडा</label>
              <select
                name="status"
                className="form-select admin-select"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="">सर्व स्थिती (All Status)</option>
                <option value="Pending">प्रलंबित (Pending)</option>
                <option value="Verified">पडताळले (Verified)</option>
                <option value="In Progress">प्रक्रियेत (In Progress)</option>
                <option value="Resolved">निकाली (Resolved)</option>
                <option value="Rejected">नाकारले (Rejected)</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label text-xs fw-bold text-uppercase text-secondary mb-1">क्षेत्रानुसार निवडा</label>
              <select
                name="village_id"
                className="form-select admin-select"
                value={filters.village_id}
                onChange={handleFilterChange}
              >
                <option value="">सर्व कार्यालय क्षेत्र (All Areas)</option>
                {villages.map((village) => (
                  <option key={village.village_id} value={village.village_id}>
                    {village.village_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label text-xs fw-bold text-uppercase text-secondary mb-1">विभागानुसार निवडा</label>
              <select
                name="department_id"
                className="form-select admin-select"
                value={filters.department_id}
                onChange={handleFilterChange}
              >
                <option value="">सर्व विभाग (All Departments)</option>
                {departments.map((dept) => (
                  <option key={dept.department_id} value={dept.department_id}>
                    {dept.department_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">तक्रारी लोड होत आहेत...</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-admin-custom">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>नागरिक</th>
                      <th>शीर्षक</th>
                      <th>विभाग</th>
                      <th>आधार क्र.</th>
                      <th>कार्यालय क्षेत्र</th>
                      <th>संलग्नक</th>
                      <th>स्थिती</th>
                      <th>स्थिती बदला</th>
                      <th>दिनांक</th>
                      <th>टोकन</th>
                    </tr>
                  </thead>
                  <tbody>
                    {complaints.length === 0 ? (
                      <tr>
                        <td colSpan="11" className="text-center py-5 text-muted">
                          कोणत्याही तक्रारी आढळल्या नाहीत.
                        </td>
                      </tr>
                    ) : (
                      complaints.map((item, index) => (
                        <tr key={item.complaint_id}>
                          <td className="fw-bold text-secondary">
                            {(page - 1) * limit + index + 1}
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <div className="admin-avatar-chip">
                                {item.citizen_name?.charAt(0)?.toUpperCase() || "N"}
                              </div>
                              <div>
                                <strong className="d-block text-dark">{item.citizen_name}</strong>
                                <small className="text-muted">{item.citizen_mobile}</small>
                              </div>
                            </div>
                          </td>
                          <td className="fw-semibold text-dark">{item.title}</td>
                          <td>
                            <span className="badge bg-light text-dark border">
                              {item.department_name}
                            </span>
                          </td>
                          <td className="text-muted">
                            {item.citizen_aadhar_no || "—"}
                          </td>
                          <td>{item.village_name}</td>
                          <td>
                            {item.image_url ? (
                              <a
                                href={`${BASE_URL}${item.image_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-action-icon btn-action-view"
                                title="संलग्नक पहा"
                              >
                                <FaEye />
                              </a>
                            ) : (
                              <span className="text-muted small">नाही</span>
                            )}
                          </td>
                          <td>
                            <span className={getStatusBadgeClass(item.status)}>
                              {getStatusLabel(item.status)}
                            </span>
                          </td>
                          <td style={{ minWidth: "160px" }}>
                            <select
                              className="form-select form-select-sm admin-select py-1 px-2 text-xs fw-semibold"
                              value={item.status}
                              disabled={updating?.id === item.complaint_id}
                              onChange={(e) =>
                                handleStatusChange(item.complaint_id, e.target.value)
                              }
                            >
                              <option value="Pending">प्रलंबित</option>
                              <option value="Verified">पडताळले</option>
                              <option value="In Progress">प्रक्रियेत</option>
                              <option value="Resolved">निकाली</option>
                              <option value="Rejected">नाकारले</option>
                            </select>

                            {updating?.id === item.complaint_id && updating?.status === "Verified" && (
                              <small className="text-primary d-block mt-1">
                                ईमेल पाठवत आहे...
                              </small>
                            )}
                          </td>
                          <td className="text-muted small">
                            {new Date(item.created_at).toLocaleDateString("mr-IN")}
                          </td>
                          <td>
                            <span className="badge bg-dark text-warning font-monospace">
                              #{item.complaint_token}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Bar */}
              <div className="admin-pagination-bar">
                <span className="admin-pagination-info">
                  पृष्ठ {page} पैकी {totalPages}
                </span>

                <div className="d-flex align-items-center gap-2">
                  <button
                    className="admin-pagination-btn"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                  >
                    « मागील
                  </button>

                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={`admin-pagination-btn ${page === i + 1 ? "active" : ""}`}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    className="admin-pagination-btn"
                    disabled={page === totalPages}
                    onClick={() => setPage(page + 1)}
                  >
                    पुढील »
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ComplaintList;
